import DvrIcon from '@mui/icons-material/Dvr';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonIcon from '@mui/icons-material/Person';
import { Card, Grid, styled, Typography, Box } from '@mui/material';
import React from 'react';
import { grades } from '../../utils/grades';
import { skills } from '../../utils/skills';

const QualCard = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    marginLeft: '0px',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    [theme.breakpoints.up('md')]: {
        marginLeft: '12px',
        width: 'calc(100% - 12px)',
    },
}));

const TeacherSkillsGrid = styled(Grid)(({ theme }) => ({
    textAlign: 'left',
    padding: '8px 8px 20px 0px',
    [theme.breakpoints.up('md')]: {
        padding: '8px 8px 20px 32px',
    },
}));

/**
 * Component for displaying a teachers qualifications.
 *
 * @component Qualifications
 * @param {object} props props
 * @param {string[]} props.grades
 * @param {string[]} props.skills
 * @param {string} props.otherSkills
 * @return (
 * <Qualifications />
 * )
 */

const Qualifications = props => {
    return (
        <Grid item xs={12} md={6}>
            <QualCard
                sx={{
                    boxShadow:
                        props.border === false
                            ? ''
                            : '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h6">
                            Skills/Qualifications:
                        </Typography>
                    </Grid>
                    <TeacherSkillsGrid item xs={2}>
                        <HowToRegIcon
                            style={{
                                'color': 'grey',
                                fontSize: 30,
                            }}
                            fontSize="large"
                        ></HowToRegIcon>
                    </TeacherSkillsGrid>

                    <TeacherSkillsGrid item xs={10} data-cy="grade-list">
                        {typeof props.grades !== 'undefined' && (
                            <div>
                                {props.grades.map(grade => {
                                    return (
                                        <Typography
                                            variant="h6"
                                            color="primary"
                                        >
                                            {
                                                grades.find(
                                                    g => g.name === grade
                                                ).title
                                            }
                                        </Typography>
                                    );
                                })}{' '}
                            </div>
                        )}
                    </TeacherSkillsGrid>

                    <TeacherSkillsGrid item xs={2}>
                        <PersonIcon
                            style={{
                                'color': 'grey',
                                fontSize: 30,
                            }}
                            fontSize="large"
                        ></PersonIcon>
                    </TeacherSkillsGrid>

                    <TeacherSkillsGrid item xs={10} data-cy="skill-list">
                        {typeof props.skills !== 'undefined' && (
                            <div>
                                {props.skills.map(skill => {
                                    return (
                                        <Typography
                                            variant="h6"
                                            color="primary"
                                        >
                                            {
                                                skills.find(
                                                    g => g.name === skill
                                                ).title
                                            }
                                        </Typography>
                                    );
                                })}{' '}
                            </div>
                        )}
                    </TeacherSkillsGrid>

                    <TeacherSkillsGrid item xs={2}>
                        <DvrIcon
                            style={{
                                'color': 'grey',
                                fontSize: 30,
                            }}
                            fontSize="large"
                        ></DvrIcon>
                    </TeacherSkillsGrid>

                    <TeacherSkillsGrid item xs={10} data-cy="other-skills">
                        {typeof props.otherSkills !== 'undefined' && (
                            <Typography variant="h6" color="primary">
                                {props.otherSkills}
                            </Typography>
                        )}
                    </TeacherSkillsGrid>
                </Grid>
            </QualCard>
        </Grid>
    );
};

export default Qualifications;
